import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { blogQuery } from '@pylot-data/hooks/blog/graphql/blogQuery'
import type { SinglePostData } from '@pylot-data/api/operations/get-singlepost'

export type BlogResult = {
    blogPosts: BlogPostsResult
}

export type BlogPostsResult = {
    items: SinglePostData[]
    total_count?: number
    total_pages?: number
}

export type blogpostVariables = {
    searchQuery?: string
    currentPage?: number
    pageSize?: number
    publishTime?: string
    allPosts?: boolean
    authorId?: string
    sortFiled?: string
}

export type GetBlogResult = BlogResult

async function getBlogs({
    searchQuery,
    currentPage,
    pageSize,
    publishTime,
    allPosts,
    authorId,
    locale,
    sortFiled
}: {
    authorId?: string
    publishTime?: string
    searchQuery?: string
    currentPage?: number
    pageSize?: number
    allPosts?: boolean
    locale: string
    sortFiled?: string
}): Promise<GetBlogResult | undefined | null> {
    const blogDataPromise = graphqlFetch<blogpostVariables, GetBlogResult>({
        query: blogQuery,
        variables: {
            searchQuery: searchQuery,
            currentPage: currentPage,
            pageSize: pageSize,
            publishTime: publishTime,
            allPosts: allPosts,
            authorId: authorId,
            sortFiled: sortFiled
        },
        locale
    })
    const [blogData] = await Promise.all([blogDataPromise])
    return {
        blogPosts: blogData?.data?.blogPosts
    }
}

export default getBlogs
